/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Data_Load_Fail_TitleInputs */

const en_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fail to load`)
};

const ar_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل في التحميل`)
};

const de_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Laden`)
};

const es_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo al cargar`)
};

const fr_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement`)
};

const it_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento non riuscito`)
};

const ja_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込みに失敗しました`)
};

const ko_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로딩 실패`)
};

const pt_br_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no carregamento`)
};

const ru_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить`)
};

const th_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โหลดไม่สำเร็จ`)
};

const tr_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüklenemedi`)
};

const zh_cn_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据读取失败`)
};

const zh_tw_dialog_data_load_fail_title = /** @type {(inputs: Dialog_Data_Load_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`資料讀取失敗`)
};

/**
* | output |
* | --- |
* | "Fail to load" |
*
* @param {Dialog_Data_Load_Fail_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_data_load_fail_title = /** @type {((inputs?: Dialog_Data_Load_Fail_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Data_Load_Fail_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_data_load_fail_title(inputs)
	if (locale === "ar") return ar_dialog_data_load_fail_title(inputs)
	if (locale === "de") return de_dialog_data_load_fail_title(inputs)
	if (locale === "es") return es_dialog_data_load_fail_title(inputs)
	if (locale === "fr") return fr_dialog_data_load_fail_title(inputs)
	if (locale === "it") return it_dialog_data_load_fail_title(inputs)
	if (locale === "ja") return ja_dialog_data_load_fail_title(inputs)
	if (locale === "ko") return ko_dialog_data_load_fail_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_data_load_fail_title(inputs)
	if (locale === "ru") return ru_dialog_data_load_fail_title(inputs)
	if (locale === "th") return th_dialog_data_load_fail_title(inputs)
	if (locale === "tr") return tr_dialog_data_load_fail_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_data_load_fail_title(inputs)
	return zh_tw_dialog_data_load_fail_title(inputs)
});